<template>
  <div class="inviteModal" >
    <ModalMiddle :is-show-close="false"
                 v-if="isShowModal"
    >
      <div slot="ModalContent"
           class="ModalContent" ref="tupuPicture"
      >

        <div id="test2" class="ModalContentBg">
          <img class="ModalContentBg" :src="bgImg" alt="">

          <div class="user-info-wrapper">
            <!-- 邀请人信息 -->
            <div class="user-info">
              <img
                :src="avatarBg"
                class="avatar">

              潮国ID：<span>{{ uniq_id }}</span>
            </div>
            <div class="txt-invite">邀请您加入潮国创意VIP会员</div>
          </div>
        </div>


        <!-- 操作按钮 -->
        <div class="handle-group">
          <div class="handle-item down" :class="{ 'ON': isDownload }"
               @click="createImage"
          >{{ isDownload ? "已下载" : "下载图片" }}
          </div>
          <div class="handle-item copy Copy"
               @click="copyLink"
          >{{ isCopy ? "复制成功" : "复制链接" }}</div>
        </div>

        <i class="icon_close"
           @click="closeModal"
        ></i>
      </div>
    </ModalMiddle>
  </div>
</template>

<script>

/* 引入公共方法和常量 */
import * as fnCommon from '@/fn/_fn';
import * as CON_COMMON from '@/constant/_constant';

/* 引入组件 */

/* 引入插件 */
import domtoimage from 'dom-to-image';
import FileSaver from 'file-saver';

/* 引入VUEX */
import {mapState} from "vuex";
import {fnLogin} from "@/fn";
import {FANS_CLUB} from "@/constant/_constant/CON_BASIC";

/* 引入API */

export default {
  name: "inviteModal"

  , components: {}

  , props: {
    type: {
      type: String,
      default: "invite"
    }
  }

  , watch: {}

  , computed: {
    ...mapState('user', [
      'avatar',
      'name',
      'uniq_id',
      'vipIsPerson',
      'vipIsPersonData',
      'vipIsBusiness',
      'vipIsBusinessData',
      'companyVipState'
    ])
  }

  , mounted() {
    let _url = "//static.588ku.com/chaotu/_chaotu/fan-club/invite%40bg2.png?v=2";
    this.getImageBase64(_url, (uu) => {
      console.log('base转化结果：', uu)
      this.bgImg = uu;
    })

    let avatar = "//static.588ku.com/chaotu/user/chaopx_avatar_new.png"
    this.getImageBase64(avatar, (uu) => {
      console.log('base转化结果：', uu)
      this.avatarBg = uu;
    })


  }
  , data() {
    return {
      isShowModal: false
      , isDownload: false
      , isCopy: false
      , bgImg: ''
      , avatarBg: ''
    }
  }

  , methods: {

    closeModal() {
      this.isShowModal = false;
    }

    , createImage() {
      let node = document.getElementById('test2');
      let that = this
      domtoimage.toPng(node)
        .then(function (dataUrl) {
          that.dataUrl = dataUrl
          FileSaver.saveAs(dataUrl, 'chaopx_invite.png');
          that.$myNotify.success("下载成功")
        })
        .catch(function (error) {
          console.error('生成失败', error);
        });

    }

    ,copyLink(){
      if (fnLogin.checkLogin()) {
        let path = fnCommon.fnBasic.getChaopxFullLink(CON_COMMON.CON_BASIC.FANS_CLUB)
        path = " 潮国创意宠粉特别活动，通过我的专属链接充值成功后获得等额潮币。现在免费送VIP，我已经领到了，你也快来领取！" + path;
        fnCommon.fnBasic.copy(path + `?i=${this.uniq_id}`)
      } else {
        fnLogin.loginIntercept(false)
      }
    }


    /** 图片url转base64, 以回调函数返回结果 */
    , getImageBase64(url, callback) {
      var Img = new Image(), dataURL = '';
      Img.src = url + '?v=' + Math.random();
      // 使用canvas去生成dataURL，避免二次请求，在创建Image对象的时候，给image对象设置了如下属性（目的是为了避免出现canvas污染的问题）
      Img.setAttribute('crossOrigin', 'Anonymous');
      Img.onload = function () {
        var canvas = document.createElement('canvas'),
          width = Img.width,
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(Img, 0, 0, width, height);
        dataURL = canvas.toDataURL('image/jpeg');
        return callback ? callback(dataURL) : null;
      };
    }
    , js_getDPI() {
      var arrDPI = new Array();
      if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
      } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
      }
      return arrDPI;
    }


  }

}
</script>

<style lang="scss" scoped>


.ModalContent {
  //@include BgImage(360px, 599px, "_chaotu/fan-club/invite%40bg.png");
  width: 360px;
  height: 471px;
  position: relative;
  background-size: 360px 599px;

  .ModalContentBg {
    display: inline-block;
    width: 360px;
    height: 471px;
    @include Position(1, 5, 0, 0);
  }

  .icon_close {
    @include BgImage(42px, 22px, "_chaotu/fan-club/icon_closed.svg");
    @include Position(1, 2, -42px, 0);
    cursor: pointer;

  }


  .user-info-wrapper {
    font-size: 12px;
    color: #252626;
    line-height: 16px;
    letter-spacing: 1px;

    @include Position(1, 5, 39px, 140px);

    .user-info {
      display: flex;
      align-items: center;

      .avatar {
        display: inline-block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin-right: 8px;
      }

    }

    .txt-invite {
      margin-top: 4px;
      height: 16px;
      font-size: 12px;
      color: #252626;
      line-height: 16px;
      letter-spacing: 1px;
    }
  }


  .handle-group {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include Position(1, 4, 0, -70px);

    .handle-item {
      width: 140px;
      height: 44px;
      border-radius: 10px;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      color: #FFFFFF;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;

      &:after {
        content: "";
        display: inline-block;
        width: 140px;
        height: 44px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        @include Position(1, 5, -2px, -2px);
        border-radius: 12px;

      }
    }

    .down {
      background: #575DFD;
      //border: 2px solid rgba(255, 255, 255, 0.3);

      &.ON {
        background: rgba(160, 163, 178, 1);
      }
    }

    .copy {
      background: linear-gradient(90deg, #FC5293 0%, #FCB925 100%);
      //border: 2px solid rgba(255,255,255,0.3);
      position: relative;


    }
  }

}
</style>
